import { render } from "./Timer.vue?vue&type=template&id=c1994580"
import script from "./Timer.vue?vue&type=script&lang=js"
export * from "./Timer.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.31.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__